export function Strength(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6V18C0 21.3137 2.68629 24 6 24H18C21.3137 24 24 21.3137 24 18V6C24 2.68629 21.3137 0 18 0H6ZM8.19531 16.7063C7.78906 16.3156 7.5625 15.8859 7.5625 15.4641C7.5625 14.7453 8.09375 14.2297 8.73438 14.2297C9.125 14.2297 9.49219 14.3625 9.98438 14.7219C10.6562 15.2219 11.4219 15.5109 12.0547 15.5109C13.0156 15.5109 13.5 15.2063 13.5 14.6203C13.5 14.1438 13.0703 13.8703 11.9844 13.6516L10.6406 13.3859C8.63281 12.9953 7.65625 11.9797 7.65625 10.2609C7.65625 8.12813 9.29688 6.8 11.9219 6.8C13.3984 6.8 14.7344 7.22969 15.4766 7.94063C15.9141 8.35469 16.1328 8.79219 16.1328 9.25313C16.1328 9.90157 15.6484 10.3469 14.9531 10.3469C14.6016 10.3469 14.2109 10.1906 13.8047 9.88594C13.1797 9.38594 12.6484 9.175 11.9531 9.175C11.1953 9.175 10.7188 9.49532 10.7188 10.0031C10.7188 10.5031 11.1406 10.8547 12.125 11.0266L13.5 11.2688C15.5078 11.6281 16.5156 12.6359 16.5156 14.2922C16.5156 16.4719 14.7031 17.8859 11.8984 17.8859C10.3359 17.8859 8.95312 17.4328 8.19531 16.7063Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
